import { ApplicationConfig, LOCALE_ID, provideZoneChangeDetection } from "@angular/core";
import { provideRouter } from "@angular/router";
import { provideHttpClient, withInterceptorsFromDi, withXhr } from "@angular/common/http";
import { CookieService } from "ngx-cookie-service";
import { NgxImageCompressService } from "ngx-image-compress";
import { routes } from "./app.routes";

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection(),
    provideRouter(routes),
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    CookieService,
    NgxImageCompressService,
    { provide: LOCALE_ID, useValue: 'de-DE' },
  ]
};
